import * as React from 'react';
import {
  PageContainerRow,
  PageContainerCol,
} from 'components/UserManagement/Profile/UserProfileTabbed/UserPrfileTab.Style';
import { Row, Col } from 'antd';
import { ExecuteBillOfLadingPaymentRequest, BillOfLadingPaymentResponse, CompleteThreeDSecureBolPaymentRequest, ICompleteThreeDSecureBolPaymentRequest, SwaggerException, BeginBillPaymentResponse, IVerifyFirstAtlanticPaymentResponse, IBeginRegisterCreditCardResponse, IBeginBillPaymentResponse } from 'Core/Api/Payment/Api';
import { withRouter, RouteComponentProps, Prompt } from 'react-router-dom';
import paymentSpinnerGif from '../../../assets/images/paymentSpinner.gif';
import { uniqueId } from 'lodash';
import { ThreeSecureIFrame, IFrameContainer } from './ThreeDSecureView.Styled';
import dummy from './dummy.json';
import ThreeDSecureHandler from './ThreeDSecureHandler';
import { PaymentProcessingModel } from '../PaymentProcessingView/PaymentProcessingModel';
import AuthContext from 'Context/AuthContext';
import Frame from 'react-frame-component';
import ConfigUtility from '../../../Core/ConfigUtility/ConfigUtility';
import Config from '../../../Core/Config.json';
import renderHTML from 'react-render-html';
import TransactionHistoryPage from 'Pages/TransactionHistoryPage';

export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
  verificationResponse?: IBeginRegisterCreditCardResponse;
  onSuccess?: Function;
  onFailure?: Function;
}

export interface State {
  formId?: string;
  html?: string;
  locationListenCallback?: Function;
  canNavigate?: boolean;
  apiResponse?: any;
}

class ThreeDSecureViewWithRouter extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  currentHandler;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  threeDSecureHandler: ThreeDSecureHandler;


  constructor(props: Props) {
    super(props);

    this.state = {
      formId: uniqueId("form")
    };
    this.iframeRef = React.createRef();
    this.threeDSecureHandler = new ThreeDSecureHandler(props);
  }

  componentDidMount() {
    let request: IBeginBillPaymentResponse | IBeginRegisterCreditCardResponse;

    if (this.props.verificationResponse) {
      request = this.props.verificationResponse;
    } else {
      request = this.props.location.state as BeginBillPaymentResponse;
    }
    this.setState({ html: request.htmlCode });
    this.iframeRef.current?.contentWindow?.parent.addEventListener("message", this.recievedIFrameMessage);

    const callback = this.props.history.listen((location, action) => {
      console.log("in listener");
      if (action != "REPLACE") {
        console.log("Will block navigation");
        this.props.history.block();
      }
    });
    this.setState({ locationListenCallback: callback });

  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.apiResponse != prevState.apiResponse) {
      this.props.history.replace('/payment-complete', this.state.apiResponse);
    }
  }

  recievedIFrameMessage = (e: MessageEvent) => {
    let config = ConfigUtility.getSync();
    if (!!!e.origin && e.origin as any != config?.PaymentApiBaseUrl) {
      return;
    }

    if (e.data && e.data.indexOf && (e.data as string)["indexOf"]("success") !== -1) {
      var sterilizedString = (e.data as string).replace('\n', "");
      var response = JSON.parse(sterilizedString) as IVerifyFirstAtlanticPaymentResponse;

      if (response.success) {
        if (this.props.onSuccess) {
          this.props.onSuccess(response);
        } else {
          this.setState({ canNavigate: true, apiResponse: response });
        }

      } else {
        if (this.props.onFailure) {
          this.props.onFailure(response);
        } else {
          this.setState({ canNavigate: true, }, () => {
            this.props.history.replace('/payment-error', response);
          });
        }
      }
    }
  }

  componentWillUnmount() {
    try {
      clearTimeout(this.currentHandler);
      this.iframeRef.current?.contentWindow?.parent.removeEventListener("message", this.recievedIFrameMessage)
      this.state.locationListenCallback?.call(this);

    } catch {

    }
  }

  render() {
    const request = this.props.location.state as PaymentProcessingModel;
    return (
      <PageContainerRow style={{ width: "100%" }}>
        <Prompt when={!this.state.canNavigate} message="Please click cancel or the transaction may fail" />

        <PageContainerCol span={24}>
          <Row>
            <Col span={24}>
              <h1>Please wait...</h1>
              <iframe ref={this.iframeRef} style={{ width: "100%", minHeight: "300px", height: "100%", border: "none" }} src={'data:text/html,' + encodeURIComponent(this.state.html ?? "<h1>please wait</h1>")}   >

              </iframe>
            </Col>
          </Row>
        </PageContainerCol>
      </PageContainerRow>
    );
  }
}

const ThreeDSecureView = withRouter(ThreeDSecureViewWithRouter);
export default ThreeDSecureView;
